import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/Index'
import InviteList from '@/pages/invite/List'
import InviteListDetail from '@/pages/invite/ListDetail'
import WinList from '@/pages/win/List'
import Login from '@/pages/common/Login'
import Forget from '@/pages/common/Forget'
import ChangePwd from '@/pages/common/ChangePwd'
import Register from '@/pages/common/Register'
import Help from '@/pages/common/Help'
import NotFound from '@/pages/common/NotFound'
import MasterCenter from '@/pages/master/MasterCenter'
import MasterMore from '@/pages/master/More'
import MasterBasicInfo from '@/pages/master/BasicInfo'
import MasterInviteManagement from '@/pages/master/ListManagement'
import MasterProcessManagement from '@/pages/master/inviteProcess/ProcessManage'
import MasterBackStandard from '@/pages/master/inviteProcess/BackStandard'
import MasterReplyInvite from '@/pages/master/inviteProcess/ReplyInvite'
import MasterDownloadDoc from '@/pages/master/inviteProcess/DownloadDoc'
import MasterQuestions from '@/pages/master/inviteProcess/Questions'
import MasterLetter from '@/pages/master/inviteProcess/Letter'
import MasterReplyTender from '@/pages/master/inviteProcess/ReplyTender'
import InfoEdit from '@/pages/common/InfoEdit'
import gatewayIndex from '@/pages/gateway/index'

import bidReturnLower from '@/pages/bid/bidReturnLower'
import bidReturnHigher from '@/pages/bid/bidReturnHigher'
import questions from '@/pages/bid/questions'
import businessNegotiation from '@/pages/bid/businessNegotiation'
import invitation from '@/pages/bid/invitation'
//合同詳情
import contract from '@/pages/contract/contract'
//订单详情
import order from '@/pages/order/add'
//结算详情
import settle from '@/pages/order/settle'
//培训手册
import guide from '@/pages/guide/guideFile'
//合同詳情
import drawingDetail from '@/pages/common/drawingDetail'

import test from '@/test'

Vue.use(Router);

export default new Router({
    routes: [{
            path: '/', //首页-未登录
            name: 'index',
            component: Index,
            children: [{
                    name: 'slide1',
                    path: 'slide1',
                    component: Index
                },
                {
                    name: 'slide2',
                    path: 'slide2',
                    component: Index
                },
                {
                    name: 'slide3',
                    path: 'slide3',
                    component: Index
                },
                {
                    name: 'slide4',
                    path: 'slide4',
                    component: Index
                },
            ]
        },
        {
            path: '/bidReturnLower/:dealId',
            name: 'bidReturnLower',
            component: bidReturnLower
        }, {
            path: '/bidReturnHigher/:dealId',
            name: 'bidReturnHigher',
            component: bidReturnHigher
        }, {
            path: '/invitation/:dealId',
            name: 'invitation',
            component: invitation
        },
        {
            path: '/questions/:dealId/:formId', //质疑、答疑
            name: 'questions',
            component: questions
        }, {
            path: '/businessNegotiation/:dealId', //质疑、答疑
            name: 'businessNegotiation',
            component: businessNegotiation
        },
        {
            path: '/invite-list', //招标公告
            name: 'invite-list',
            component: InviteList
        },
        {
            path: '/invite-listDetail/:id/:type', //招标公告 详情
            name: 'invite-listDetail',
            component: InviteListDetail
        },
        {
            path: '/win-list', //中标公告
            name: 'win-list',
            component: WinList
        },
        {
            path: '/login/:url', //登录
            name: 'login',
            component: Login
        },
        {
            path: '/forget', //忘记密码
            name: 'forget',
            component: Forget
        },
        {
            path: '/changePwd', //忘记密码
            name: 'changePwd',
            component: ChangePwd
        },
        {
            path: '/register', //注册页面
            name: 'register',
            component: Register
        },
        {
            path: '/help', //帮助中心
            name: 'help',
            component: Help
        },
        {
            path: '/not-found', //404
            name: 'not-found',
            component: NotFound
        },
        {
            path: '/master/center', //管理中心
            name: 'master-center',
            component: MasterCenter
        },
        {
            path: '/master/infoEdit', //管理中心
            name: 'master-infoEdit',
            component: InfoEdit
        },
        {
            path: '/master/more/:activeName', //管理中心 查看更多
            name: 'master-more',
            component: MasterMore
        },
        {
            path: '/master/basicInfo', //基本信息
            // path: '/basicInfo/:id',//基本信息
            name: 'master-basicInfo',
            component: MasterBasicInfo
        },
        {
            path: '/master/inviteManagement', //招标管理
            name: 'master-inviteManagement',
            component: MasterInviteManagement,

        },
        {
            path: '/master/processManagement/:id', //招标管理,流程进度
            name: 'master-processManagement',
            component: MasterProcessManagement
        },
        {
            path: '/master/backStandard/:formId/:id/:entrance/:status', //招标管理,回标
            name: 'master-backStandard',
            component: MasterBackStandard
        },
        {
            path: '/master/replyInvite/:formId/:entrance', //招标管理,回复邀请函
            name: 'master-replyInvite',
            component: MasterReplyInvite,
            props: true
        },
        {
            path: '/master/downloadDoc/:formId/:entrance', //招标管理,下载标书
            name: 'master-downloadDoc',
            component: MasterDownloadDoc
        },
        {
            path: '/master/questions/:formId/:entrance', //招标管理,质疑/答疑
            name: 'master-questions',
            component: MasterQuestions
        },
        {
            path: '/master/replyTender/:formId/:entrance', //招标管理,询标回复
            name: 'master-replyTender',
            component: MasterReplyTender
        },
        {
            path: '/master/letter/:formId/:entrance', //招标管理,中标通知书/感谢信
            name: 'master-letter',
            component: MasterLetter
        },
        {
            path: '/gateway/index', //招标管理,中标通知书/感谢信
            name: 'gateWayIndex',
            component: gatewayIndex
        },
        {
            path: '/contract/:type/:cid',
            name: 'contract',
            component: contract
        }, {
            path: '/order/:type/:id',
            name: 'order',
            component: order
        }, {
            path: '/settle/:type/:id',
            name: 'settle',
            component: settle
        }, {
            path: '/settle/add',
            name: 'settle',
            component: settle
        }, {
            path: '/guide',
            name: 'guide',
            component: guide
        }, {
            path: '/drawingDetail',
            name: 'drawingDetail',
            component: drawingDetail
        }, {
            path: '/test',
            name: 'test',
            component: test
        }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js